import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const ValedictoryCeremony2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/9.webp`;
    const p10  = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/11.webp`;
    const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/12.webp`;
    const p13 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/13.webp`;
    const p14 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/14.webp`; 
    const p15 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/15.webp`;
    const p16 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/16.webp`;
    const p17 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/17.webp`;
    const p18 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/18.webp`;
    const p19 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/19.webp`;
    const p20 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/20.webp`;
    const p21 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/21.webp`;
    const p22 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/22.webp`;
    const p23 = `${config.base_image_url_2025}/home/events-activities/school-programs/ValedictoryCeremony2025/23.webp`;

     

1
   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
},
{
  src: p13,
  source: p13,
  rows: 1,
  cols: 1,
},
{
  src: p14,
  source: p14,
  rows: 1,
  cols: 1,
},
{
  src: p15,
  source: p15,
  rows: 1,
  cols: 1,
},
{
  src: p16,
  source: p16,
  rows: 1,
  cols: 1,
},
{
  src: p20,
source:p20, 
rows : 1, 
cols : 1
},
{
  src: p21,
  source: p21,
  rows: 1,
  cols: 1,
},
{
  src: p22,
  source: p22,
  rows: 1,
  cols: 1,
},
{
  src: p23,
  source: p23,
  rows: 1,
  cols: 1,
}
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                               VALEDICTORY CEREMONY 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Date: 29 January 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                On 29 January 2026, National Public School, Yeshwanthpur hosted the Valedictory Ceremony for students of Classes9–12. The event commenced with a stately march past by the cabinet members, reflecting grace and discipline. In a symbolic gesture of continuity, the outgoing cabinet ceremonially handed over their responsibilities to their successors, marking the transfer of leadership.
                                <br></br>
                                The Class 12 cabinet members were honoured with Certificates of Commendation presented by the Principal
                                Ms. Sheeja Manoj. This was followed by the felicitation of students who had excelled academically during the
                                2024–25 session, with trophies and certificates awarded in recognition of their achievements. The highlight of the
                                ceremony was the presentation of the Best Outgoing Student Award, which was received amidst resounding applause
                                and cheers.
                                <br></br>
                                The Principal delivered an inspiring address, commending the discipline and dedication of the graduating Class 12 students and encouraged them to pursue their future endeavours with determination and integrity.
                               <br></br>
                                The ceremony concluded with a heartfelt note of gratitude, leaving the audience overwhelmed and motivated to strive for excellence. The event stood as a testament to the school’s commitment to nurturing leadership, disciplineand academic brilliance.
                              <br></br>
                                The celebration successfully highlighted the importance of incorporating sports into our daily lives. It instilled a sense of unity, healthy competition, and respect for physical well-being among the students. The Principal, in the closing speech, appreciated the efforts of the organizing committee and encouraged students to continue participating in sports with the same zeal throughout the year. 
                               <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Keep your face always toward the sunshine and shadows will fall behind you. – Walt Whitman”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ValedictoryCeremony2025;